import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// httpOnly cookie auth — send credentials on every request; no token handling in JS.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});
